import type {
  ScheduleStrategySummary,
  ScheduleSummaryTotals,
} from '../types/schedule';

/**
 * Aggregate day-level totals from a basket-filtered strategy list so the
 * embedded Live-tab hero banner reflects basket scope, not platform scope.
 * Mirrors the backend aggregator in
 * `lambda_functions/strategy/schedule_viewer.py` `_build_strategies_summary`:
 * rejected and cancelled are summed into separate buckets (cancelled is
 * user-/system-initiated, not a broker failure).
 */
export function computeBasketTotals(
  strategies: ScheduleStrategySummary[],
): ScheduleSummaryTotals {
  const t: ScheduleSummaryTotals = {
    leg_count: 0,
    open_count: 0,
    closed_count: 0,
    filled: 0,
    pending: 0,
    rejected: 0,
    cancelled: 0,
    realized_pnl: 0,
    unrealized_pnl: 0,
    total_pnl: 0,
    sl_placed: 0,
    sl_rejected: 0,
    sl_pending: 0,
  };
  for (const s of strategies) {
    t.leg_count += s.leg_count;
    t.open_count += s.open_count;
    t.closed_count += s.closed_count;
    t.filled += s.entry_counts.complete;
    t.pending += s.entry_counts.pending;
    t.rejected += s.entry_counts.rejected;
    t.cancelled += s.entry_counts.cancelled;
    t.realized_pnl += s.realized_pnl;
    t.unrealized_pnl += s.unrealized_pnl;
    t.total_pnl += s.total_pnl;
    t.sl_placed += s.sl_counts.placed;
    t.sl_rejected += s.sl_counts.rejected;
    t.sl_pending += s.sl_counts.pending;
  }
  return t;
}
